export default __webpack_public_path__ + "static/media/toolTip_Indication.c8eeaeb5.png";